import { LinkType } from 'app/core/components/workflow-new/common/link-type';
import { Observable } from 'rxjs/Observable';

export class BaseCardConfiguration {
    tagType: string;
    classType: string;
    expired: boolean;
    thumbnail: string;
    action: LinkActions;
    clickable: boolean;
    multiContent: boolean;
    observableAction: Observable<any>;
    target: string[];
    imageWidth: string = '134';
    imageHeight: string = '134';
    cardHeight: string = '200';
    cardWidth: string;
    links?: LinkType[];
}

export enum LinkActions {
    REDIRECT, DOWNLOAD, EXPAND, BLOB, MODAL, ACTION, SSO
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/common/base-card-configuration.ts